import React, { useState } from 'react';
import './register.css';



const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',   
    birthDate: '',
    email: '',
    password: '',
    confirmPassword: '',
    kvkk1: false,
    kvkk2: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{9,}$/;

    if (!formData.firstName) newErrors.firstName = 'İsim gerekli';
    if (!formData.lastName) newErrors.lastName = 'Soyisim gerekli';
    if (!formData.birthDate) newErrors.birthDate = 'Doğum tarihi gerekli';
    if (!formData.email) newErrors.email = 'E-posta gerekli';
    if (!formData.password) {
      newErrors.password = 'Şifre gerekli';
    } else if (!passwordRegex.test(formData.password)) {
      newErrors.password = 'Şifre en az dokuz karakter, bir büyük harf, bir küçük harf ve bir sayı içermelidir';
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Şifreler eşleşmiyor';
    }
    if (!formData.kvkk1) newErrors.kvkk1 = 'KVKK metni onaylanmalı';
    if (!formData.kvkk2) newErrors.kvkk2 = 'KVKK metni onaylanmalı';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await fetch('http://localhost:5104/api/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          if (response.status === 409) {
            setErrors({ ...errors, email: 'Bu e-posta adresi ile zaten bir kayıt bulunmaktadır.' });
          } else {
            throw new Error('Network response was not ok');
          }
        } else {
          const data = await response.json();
          console.log('Form submitted successfully:', data);
  
          // Clear form fields after successful submission if needed
          setFormData({
            firstName: '',
            lastName: '',
            birthDate: '',
            email: '',
            password: '',
            confirmPassword: '',
            kvkk1: false,
            kvkk2: false,
          });
  
          // Display success message or redirect to another page
          alert('Kayıt başarılı!');
        }
      } catch (error) {
        console.error('There was a problem with the form submission:', error);
        setErrors({ ...errors, general: 'Kayıt gönderimi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.' });
      }
    }
  };


  return (
    <div className="registration-form">
      <h2>Kayıt Ol</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>İsim</label>
          <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
          {errors.firstName && <span className="error">{errors.firstName}</span>}
        </div>
        <div className="form-group">
          <label>Soyisim</label>
          <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
          {errors.lastName && <span className="error">{errors.lastName}</span>}
        </div>
        <div className="form-group">
          <label>Doğum Tarihi</label>
          <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} />
          {errors.birthDate && <span className="error">{errors.birthDate}</span>}
        </div>
        <div className="form-group">
          <label>E-posta</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
        <div className="form-group">
          <label>Şifre</label>
          <input type="password" name="password" value={formData.password} onChange={handleChange} />
          {errors.password && <span className="error">{errors.password}</span>}
        </div>
        <div className="form-group">
          <label>Şifre Tekrar</label>
          <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} />
          {errors.confirmPassword && <span className="error">{errors.confirmPassword}</span>}
        </div>
        <div className="form-group">
          <p>Kişisel Verilerin Korunması ve İşlenmesi Şartları Hakkında Aydınlatma Metnini Okudum, Anladım.</p>
          <input type="checkbox" name="kvkk1" checked={formData.kvkk1} onChange={handleChange} />
          {errors.kvkk1 && <span className="error">{errors.kvkk1}</span>}
        </div>
        <div className="form-group">
          <p>Kişisel Verilerin İşlenmesi ve Aktarılmasına İlişkin Açık Rıza Formunu Okudum Onaylıyorum.</p>
          <input type="checkbox" name="kvkk2" checked={formData.kvkk2} onChange={handleChange} />
          {errors.kvkk2 && <span className="error">{errors.kvkk2}</span>}
        </div>
        <button type="submit">Kayıt Ol</button>
        {errors.general && <span className="error">{errors.general}</span>}
      </form>
    </div>
  );
};

export default RegistrationForm;
